import '@utilities/prototypes';
import Vue from 'vue';
import analytics from 'playposit-analytics';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueSweetalert2 from 'vue-sweetalert2';
import PlaypositErrorScreen from '@components/error-screen';
import PlaypositOffline from '@components/offline';
import PlaypositBulbSettings from '@components/bulb-settings';
import ChickFilATagButton from '@components/chickfila-tag';
import Vuelidate from 'vuelidate';
import TinyMCE from '@components/tiny-mce';
import * as PlaypositUtilities from '@utilities';
import _ from 'lodash';
import Tooltip from '@snippets/vue/Tooltip.vue';
import router from './router';
import Playlist from './Playlist.vue';
import store from './store';
import vuetify from './plugins/vuetify';

import './assets/fonts/fonts.css';
import './plugins/api';

// attach lodash as a prop to use in vue html rendering
Object.defineProperty(Vue.prototype, '_', { value: _ });

// Setting up our namespaced debugging object:
window.PP = {};

analytics.updateOptions({
  debug: true,
  version: '1.00',
});

Vue.use(Vuelidate);
Vue.use(PlaypositOffline);
Vue.use(ChickFilATagButton);
Vue.use(VueSweetalert2);
Vue.use(PlaypositBulbSettings);
Vue.use(PlaypositUtilities);
Vue.use(PlaypositErrorScreen);
Vue.use(TinyMCE);
Vue.component('Tooltip', Tooltip);
Vue.config.productionTip = false;


new Vue({
  router,
  store,
  vuetify,
  render: h => h(Playlist),
}).$mount('#app');
